// src/api/variableIncomes.js - FIXED
import api from './config';

export const variableIncomesAPI = {
  /**
   * Obtener ingresos variables de un empleado
   * ✅ Construye URL manualmente para evitar problemas
   */
  get: async (employeeId, periodo, quincena) => {
    try {
      // Construir URL manualmente
      const url = `/payroll-incomes?employee_id=${employeeId}&periodo=${periodo}&quincena=${quincena}`;
      console.log('📡 GET Variable Incomes:', url);
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        console.log('ℹ️ No hay ingresos variables para:', employeeId, periodo, quincena);
        return null; // No hay ingresos guardados
      }
      throw error;
    }
  },

  /**
   * Crear o actualizar ingresos variables (UPSERT)
   * 🔧 CRITICAL: Backend espera snake_case
   */
  upsert: async (data) => {
    // ✅ Asegurar que todos los campos estén en snake_case
    const payload = {
      employee_id: data.employee_id,
      periodo: data.periodo,
      quincena: data.quincena,
      company_id: data.company_id,
      payroll_id: data.payroll_id || null,
      horas_extras: parseFloat(data.horas_extras || 0),
      comisiones: parseFloat(data.comisiones || 0),
      vacaciones: parseFloat(data.vacaciones || 0),
      incentivos: parseFloat(data.incentivos || 0),
      bonificaciones: parseFloat(data.bonificaciones || 0),
      otros_ingresos: parseFloat(data.otros_ingresos || 0),
      detalles: data.detalles || {}
    };

    console.log('📤 API enviando payload:', payload);

    const response = await api.post('/payroll-incomes/upsert', payload);
    return response.data;
  },

  /**
   * Eliminar ingresos variables
   */
  delete: async (id) => {
    const response = await api.delete(`/payroll-incomes/${id}`);
    return response.data;
  },

  /**
   * Obtener solo el total (rápido)
   */
  getTotal: async (employeeId, periodo, quincena) => {
    try {
      const data = await variableIncomesAPI.get(employeeId, periodo, quincena);
      return data?.total_ingresos || 0;
    } catch (error) {
      return 0;
    }
  },

  /**
   * Obtener breakdown completo
   */
  getBreakdown: async (employeeId, periodo, quincena) => {
    try {
      const data = await variableIncomesAPI.get(employeeId, periodo, quincena);
      if (!data) {
        return {
          horas_extras: 0,
          comisiones: 0,
          vacaciones: 0,
          incentivos: 0,
          bonificaciones: 0,
          otros_ingresos: 0,
          total_ingresos: 0,
          detalles: null
        };
      }
      return {
        horas_extras: parseFloat(data.horas_extras || 0),
        comisiones: parseFloat(data.comisiones || 0),
        vacaciones: parseFloat(data.vacaciones || 0),
        incentivos: parseFloat(data.incentivos || 0),
        bonificaciones: parseFloat(data.bonificaciones || 0),
        otros_ingresos: parseFloat(data.otros_ingresos || 0),
        total_ingresos: parseFloat(data.total_ingresos || 0),
        detalles: data.detalles
      };
    } catch (error) {
      console.error('Error getting breakdown:', error);
      return {
        horas_extras: 0,
        comisiones: 0,
        vacaciones: 0,
        incentivos: 0,
        bonificaciones: 0,
        otros_ingresos: 0,
        total_ingresos: 0,
        detalles: null
      };
    }
  }
};

export default variableIncomesAPI;
